export default __webpack_public_path__ + "static/rectangle@3x-5c08e2a295186094746b01633f3e4693.png";